// extracted by css-extract-rspack-plugin
module.exports =  {"box":"PtinRequiredView__box___VY6it","image":"PtinRequiredView__image___QYf_X"};